import React from 'react';
import {BooleanField, Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {schoolYears} from "../../components";

const MonTuChonFilter = (props) => (
    <Filter {...props} >
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const AdmissionReportTemplateList = props => (
    <List filters={<MonTuChonFilter/>} {...props}
          exporter={false} bulkActions={false}
          filterDefaultValues={{schoolYearId: (schoolYears && schoolYears.length > 0) ? schoolYears[0].id : null}}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="title"/>
            <BooleanField source="active"/>
        </Datagrid>
    </List>
);

export default AdmissionReportTemplateList
